import React from "react";
import { InputText, Label } from "../../../../components/Inputs";

const PersonForm = React.forwardRef(function PersonForm(
  { className = "", model = {}, updateable, disabled },
  ref,
) {
  const getState = (props) => {
    const { model } = props;
    return {
      firstname: model.firstname || "",
      lastname: model.lastname || "",
      telephoneNumber: model.telephoneNumber || "",
      cellNumber: model.cellNumber || "",
      fax: model.fax || "",
      email: model.email || "",
      emailAvis: model.emailAvis || "",
    };
  };

  const [state, setState] = React.useState(() => getState({ model }));

  // replica of componentWillReceiveProps: resyncs only when updateable
  React.useEffect(() => {
    updateable && setState(getState({ model }));
  }, [updateable, model]);

  React.useImperativeHandle(ref, () => ({
    getModel: () => {
      const modelData = { ...state };
      modelData.id = 0;
      return modelData;
    },
  }));

  const {
    firstname,
    lastname,
    telephoneNumber,
    cellNumber,
    email,
    fax,
    emailAvis,
  } = state;
  return (
    <div className={className}>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor="firstname">{`Vorname`}</Label>
          <InputText
            id="firstname"
            data-test-id="firstname"
            className="w3-block w3-border"
            value={firstname}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, firstname: value }));
            }}
            disabled={disabled}
          />
        </div>
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor="lastname">{`Nachname`}</Label>
          <InputText
            id="lastname"
            data-test-id="lastname"
            className="w3-block w3-border"
            value={lastname}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, lastname: value }));
            }}
            disabled={disabled}
          />
        </div>
      </div>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor="telephoneNumber">{`Telefon`}</Label>
          <InputText
            id="telephoneNumber"
            data-test-id="telephoneNumber"
            className="w3-block w3-border"
            value={telephoneNumber}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, telephoneNumber: value }));
            }}
            disabled={disabled}
          />
        </div>
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor="cellNumber">{`Mobil`}</Label>
          <InputText
            id="cellNumber"
            data-test-id="cellNumber"
            className="w3-block w3-border"
            value={cellNumber}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, cellNumber: value }));
            }}
            disabled={disabled}
          />
        </div>
      </div>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor="fax">{`Fax`}</Label>
          <InputText
            id="fax"
            data-test-id="fax"
            className="w3-block w3-border"
            value={fax}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, fax: value }));
            }}
            disabled={disabled}
          />
        </div>
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor="email">{`E-Mail`}</Label>
          <InputText
            id="email"
            data-test-id="email"
            className="w3-block w3-border"
            value={email}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, email: value }));
            }}
            disabled={disabled}
          />
        </div>
      </div>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor="emailAvis">{`E-Mail Avis`}</Label>
          <InputText
            id="emailAvis"
            data-test-id="emailAvis"
            className="w3-block w3-border"
            value={emailAvis}
            onChange={(event) => {
              const value = event.target.value;
              setState((prev) => ({ ...prev, emailAvis: value }));
            }}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
});

export default PersonForm;
